'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var notfound = exports.notfound = {
  title: 'Error 404',
  background_url: 'https://lib.tutellus.com/images/404-banner.svg',
  description: 'Lo sentimos, pero la página a la que intentas acceder no existe. ¿Quieres volver atrás?',
  goback: 'Volver'
};


//////////////////
// WEBPACK FOOTER
// ../i18n/lib/es/notfound.js
// module id = 702
// module chunks = 0